import { render, staticRenderFns } from "./CmdrTrade.vue?vue&type=template&id=398a56be&"
import script from "./CmdrTrade.vue?vue&type=script&lang=js&"
export * from "./CmdrTrade.vue?vue&type=script&lang=js&"
import style0 from "./CmdrTrade.vue?vue&type=style&index=0&id=398a56be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports